import "../../Session/SessionProvider.js";
import { UserType as e } from "../../Session/types/propsType.js";
const t = {
  [e.ANONYMOUS]: "guest",
  [e.REGISTERED]: "customer",
  [e.ABO]: "abo",
  [e.MEMBER]: "member"
};
export {
  t as default
};
//# sourceMappingURL=userProfileRegistry.js.map
